import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  Grid,
} from "@material-ui/core";
import InstantaneousCharge from "./InstantaneousCharge";
import SummaryAllCHGR from "./summaryAllCHGR";


const SmartChargingOutput = (props) => {
  const classes = useStyles();


  return (
    <div className={classes.root}>
      <Grid container spacing={1} >

        <Grid item md={6} xs={6}>
          <InstantaneousCharge />
        </Grid>

        <Grid item md={6} xs={6}>
          <SummaryAllCHGR />
        </Grid>

      </Grid>
    </div>
  );
};

export default SmartChargingOutput;


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
  },
  content: {
    // marginTop: theme.spacing(1),
  },
  policy: {
    // marginTop: theme.spacing(1),
    display: "flex",
    alignItems: "center",
  },
}));